import React, { FC } from 'react';
import { TouchableWithoutFeedback, View, Text } from 'react-native';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { isPhone, isWeb } from '@helpers';
import { ItemNameProps } from '@v2/pages/batch/details/modules/batch/interfaces';

export const ItemName: FC<ItemNameProps> = ({
  onPress,
  C,
  text,
  scale: scaleProp = scale,
  font: fontProp = font,
  containerStyle,
  textStyle,
  testID,
}) => {
  if (!text) return null;

  return (
    <TouchableWithoutFeedback onPress={onPress} testID={testID}>
      <View
        style={[
          { alignItems: 'center', flexDirection: 'row', gap: scaleProp(isPhone ? 0 : 4), minWidth: 0 },
          isWeb && { cursor: 'pointer' },
          containerStyle,
        ]}
      >
        <Text
          numberOfLines={1}
          style={[
            fontProp['Body'],
            { color: C('Link/Light/Primary'), flexShrink: 1, minWidth: 0 },
            isPhone && { flexGrow: 1, textAlign: 'right' },
            textStyle,
          ]}
        >
          {text}
        </Text>
        <Svg
          icon="arrowLight"
          width={scaleProp(24)}
          height={scaleProp(24)}
          color={C('Link/Light/Primary')}
          transform={[{ translateX: scaleProp(4) }]}
        />
      </View>
    </TouchableWithoutFeedback>
  );
};
